import React from 'react';

import CommonPopper from '../../components/common-popper/CommonPopper';
import TableDropdownList from './TableDropdownList';

const TablePopper = ({ content = [] }) => {
  return content.length ? (
    <CommonPopper disablePortal={false} component={() => <TableDropdownList content={content} />}>
      {content.length}
    </CommonPopper>
  ) : (
    '-'
  );
};

export default TablePopper;
